// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1IksY","container":"App_container__16xz_"};